import { FILESIZE_THRESHOLD_TO_FORCE_SHOW_UPLOADER, MIN_FILES_TO_SHOW_UPLOADER } from './bulkUploader.constants.js';

const shouldShowBulkUploaderUi = (uploadFiles) => {
  const hasLargeFile = uploadFiles.some((uploadFile) => uploadFile.file.size > FILESIZE_THRESHOLD_TO_FORCE_SHOW_UPLOADER);
  return uploadFiles.length >= MIN_FILES_TO_SHOW_UPLOADER || hasLargeFile;
};

export { shouldShowBulkUploaderUi };
//# sourceMappingURL=shouldShowBulkUploaderUi.js.map
